import { useState } from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { IamRole } from '@bumble/app/__generated__/data-contracts';

interface IamUserEditProps {
  onSubmit: () => void;
  iamUserId: string;
  role: IamRole;
}

export const IamUserEdit = ({
  onSubmit, iamUserId, role
}: IamUserEditProps) => {
  const api = useApi();

  const [newRole, setNewRole] = useState<IamRole>(role)

  const IamRoleUpdatePost = useMutation(api.iamUserUpdateRoleApiV1IamUserUpdateRolePost, {
    onSuccess() {
      toast.success('Updated IAM role successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = () => {
    IamRoleUpdatePost.mutate({
      iam_user_id: iamUserId,
      new_role: newRole,
    });
  };

  return (
    <Box pt={2}>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <InputLabel id="role-label">Role</InputLabel>
          <Select
            labelId="role-label"
            id="role"
            label="Role"
            value={newRole}
            onChange={(e) => {
              setNewRole(e.target.value as IamRole)
            }}
          >
            {Object.values(IamRole).map((r) => (
              <MenuItem key={r} value={r}>
                {r}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit} disabled={!(newRole)}>
          Save IAM Role
        </Button>
      </Box>
    </Box>
  );
};
